module.exports = __webpack_public_path__ + "static/badgecasestudyll-5c01fcde4ee0288dccea1c685b9221d5.svg";